export const FIRST_STEP_TITLE = "Ready to publish your changes?";
export const FIRST_STEP_SUBTITLE
  = "Please note that the publishing process may take some time. During this processing period, further editing won't be possible. Are you certain you've completed your edits and are ready to publish?";
export const LABEL = "Add a description for your changes";
export const SECOND_STEP_SUBTITLE
  = "To help track your changes, please provide a description. This description will be associated with the version you're about to Publish.";
export const SECOND_STEP_TITLE = "Name your changes";
export const FIRST_STEP_BUTTON_TEXT = "Continue";
export const SECOND_STEP_BUTTON_TEXT = "Publish";
export const DRAFT_ERRORS = {
  CONFLICT: {
    title: "Edit mode conflict",
    text: "It seems you're trying to enter edit mode, but another user is currently editing this agent. To ensure a smooth experience, please refresh the page to see the most up-to-date status."
  },
  PUBLISH: {
    title: "Publishing error",
    text: "We encountered an error while attempting to publish your changes. Please refresh the page to resolve this issue."
  },
  UPDATE: {
    title: "System error notification",
    text: "A system error has occurred. Please refresh the page to resolve this issue."
  }
};

export const REFRESH_PAGE = "Refresh page";

export const POPOVERS = {
  BUILD_DRAFT: {
    title: "Building your agent",
    body: "Your agent is currently being built. You'll be notified once the process is complete, allowing you to preview and publish it.",
    buttonText: "Got it"
  },
  DRAFT_EXPIRATION: {
    title: "Edit Mode Expiration Notice",
    body: "You are currently in edit mode, which will automatically log out after 2-days to ensure the security of your work. Please make sure to publish your work before the 2-days period expires.",
    buttonText: "Got it"
  },
  SET_LIVE: {
    title: "Publishing in progress!",
    body: "The new version of your AI Agent is on its way! You’ll be notified once the process is complete.",
    buttonText: "Got it"
  },
  UNASSIGNED: {
    title: "You have unconnected items",
    body: "Your agent is now being built. Please note that some items are not assigned, so they won’t be active on the agent:",
    buttonText: "Got it"
  },
  PREPARE_PREVIEW: {
    title: "Preparing your AI agent",
    body: "Configuring your agent for testing, which may take a few moments. You’ll be notified once it’s ready.",
    buttonText: "Got it"
  }
};

export const DONT_SHOW_AGAIN_STORAGE = {
  UNASSIGNED: "unassigned",
  DRAFT_EXPIRATION: "draftExpiration",
  BUILD_DRAFT: "buildDraft",
  SET_LIVE: "setLive",
  PREPARE_PREVIEW: "preparePreview"
};

